import type { TBaseModalSize } from '../base-modal.types';

const BASE_MODAL_SIZE: Record<TBaseModalSize, string> = {
	sm: 'w-[480px] max-[540px]:w-[90%] max-[540px]:max-w-[480px]',
	md: 'w-[640px] max-[720px]:w-[92%] max-[720px]:max-w-[640px]',
	lg: 'w-[calc(100%-2rem)] max-w-[960px]',
	xl: 'w-[1226px] max-[1280px]:w-[95vw] max-[1280px]:max-w-[1226px]'
} as const;

const BASE_MODAL_HEIGHT_FIXED: Record<TBaseModalSize, string> = {
	sm: 'h-fit max-h-[90vh]',
	md: 'h-fit max-h-[90vh]',
	lg: 'h-[600px] max-h-[90vh]',
	xl: 'h-[680px] max-h-[90vh]'
} as const;

const BASE_MODAL = {
	CLOSE_LABEL: 'Fechar',
	OVERLAY_Z: 'z-[9998]',
	CONTENT_Z: 'z-[9999]',
	DEFAULT_TITLE_ID: 'base-modal',
	DESCRIPTION_ID_SUFFIX: '-desc'
} as const;

export { BASE_MODAL_SIZE, BASE_MODAL_HEIGHT_FIXED, BASE_MODAL };
